var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2006_4483",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2006_4483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2403 14.7404C12.5377 14.7404 11.9438 14.4978 11.4585 14.0127C10.9734 13.5275 10.7308 12.9335 10.7308 12.2309C10.7308 11.5281 10.9734 10.9342 11.4585 10.4491C11.9438 9.96383 12.5377 9.7212 13.2403 9.7212C13.9431 9.7212 14.537 9.96383 15.0221 10.4491C15.5074 10.9342 15.75 11.5281 15.75 12.2309C15.75 12.9335 15.5074 13.5275 15.0221 14.0127C14.537 14.4978 13.9431 14.7404 13.2403 14.7404ZM13.2396 13.6154C13.6218 13.6154 13.9483 13.4803 14.2191 13.2102C14.4897 12.94 14.625 12.6138 14.625 12.2316C14.625 11.8494 14.4899 11.5229 14.2196 11.2521C13.9495 10.9815 13.6233 10.8462 13.2411 10.8462C12.8588 10.8462 12.5324 10.9813 12.2618 11.2516C11.9911 11.5217 11.8558 11.8479 11.8558 12.2301C11.8558 12.6124 11.9909 12.9388 12.261 13.2095C12.5312 13.4801 12.8574 13.6154 13.2396 13.6154ZM3.375 12.7934V11.6684H9.08663V12.7934H3.375ZM4.75969 8.27895C4.05694 8.27895 3.463 8.03633 2.97788 7.55108C2.49263 7.06595 2.25 6.47202 2.25 5.76927C2.25 5.06664 2.49263 4.4727 2.97788 3.98745C3.463 3.50233 4.05694 3.25977 4.75969 3.25977C5.46231 3.25977 6.05625 3.50233 6.5415 3.98745C7.02663 4.4727 7.26919 5.06664 7.26919 5.76927C7.26919 6.47202 7.02663 7.06595 6.5415 7.55108C6.05625 8.03633 5.46231 8.27895 4.75969 8.27895ZM4.75894 7.15395C5.14119 7.15395 5.46763 7.01883 5.73825 6.74858C6.00888 6.47845 6.14419 6.15227 6.14419 5.77002C6.14419 5.38777 6.00912 5.06133 5.739 4.7907C5.46875 4.52008 5.14256 4.38477 4.76044 4.38477C4.37819 4.38477 4.05169 4.51983 3.78094 4.78995C3.51031 5.0602 3.375 5.38639 3.375 5.76852C3.375 6.15077 3.51012 6.47727 3.78038 6.74802C4.0505 7.01864 4.37669 7.15395 4.75894 7.15395ZM8.91338 6.33177V5.20677H14.625V6.33177H8.91338Z",
    fill: "#2C357D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageInfo);
export default __webpack_public_path__ + "static/media/page_info.5978e3d0aab7eace1ec53c69a167a962.svg";
export { ForwardRef as ReactComponent };